import { formatCurrency } from "medere-ui-framework";
import { BudgetDTO } from "../../../dto/budget/BudgetDTO";
import { BudgetDetailDTO } from "../../../dto/budget/BudgetDetailDTO";
import { BILL_ITEM_CATEGORIES, BILL_ITEM_CATEGORY_CONFIG, getBudgetTotal, getCategorySubtotal } from "./billItems";

/** Resumen a todo el ancho: subtotal de cada categoría y total de la facturación, sumados con big.js. */
export default function BillSummary({ budget }: { budget: BudgetDTO }) {
    return (
        <section className="nv-card" aria-labelledby="nv-summary-title">
            <h2 className="nv-section-title" id="nv-summary-title">Resumen</h2>
            <dl className="nv-summary-grid">
                {BILL_ITEM_CATEGORIES.map(category => {
                    const subtotal = getCategorySubtotal((budget[category] ?? []) as BudgetDetailDTO[]).toNumber();
                    return (
                        <div key={category} className="nv-ro">
                            <dt className="nv-ro-label">{BILL_ITEM_CATEGORY_CONFIG[category].title}</dt>
                            <dd className={subtotal ? 'nv-ro-value nv-strong' : 'nv-ro-value nv-muted'}>{formatCurrency(subtotal)}</dd>
                        </div>
                    );
                })}
            </dl>
            <hr className="nv-divider" />
            <div className="nv-summary-total">
                <span className="nv-section-title">Total</span>
                <span className="nv-kpi">{formatCurrency(getBudgetTotal(budget).toNumber())}</span>
            </div>
        </section>
    );
}
